export default __webpack_public_path__ + "static/media/nurse1.509aee34.jpeg";